import React, { useEffect } from "react";
import "./Newsclippings.css";

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

const images = [
  "new26-08.jpg",
  "new03-07-1.jpg",
  "new03-07.jpg",
  "new30-06.jpg",
  "new24-06-1.jpg",
  "new24-06.jpg",
  "new20.05.2.jpg",
  "new20.05.1.jpg",
];

function NewsClippings() {

  useEffect(() => {
    Fancybox.bind("[data-fancybox='gallery']", {
      Thumbs: false,
      Toolbar: {
        display: [
          "zoom",
          "close",
        ],
      },
    });

    return () => {
      Fancybox.destroy();
    };
  }, []);

  return (
    <>
      {/* Banner */}
      <div className="inner-banner-wrapper">
        <img
          src="/images/page-banner/gallery.png"
          alt="Banner"
          className="inner-banner-img"
        />

        <div className="inner-banner-overlay">
          <div className="inner-banner-text">News Clippings</div>
        </div>
      </div>

      {/* News Clipping Grid */}
      <div className="overview-container">
        <div className="newsclipping-container">

          {images.map((img, index) => (
            <div className="newsclipping-item" key={index}>
              <a
                href={`/images/newsclippings/${img}`}
                data-fancybox="gallery"
              >
                <img
                  src={`/images/newsclippings/${img}`}
                  alt="news"
                  className="newsclipping-image"
                />

                <div className="newsclipping-overlay">
                  <i className="bi bi-eye newsclipping-icon"></i>
                </div>
              </a>
            </div>
          ))}

        </div>
      </div>
    </>
  );
}

export default NewsClippings;